<template>
  <tabs :tabs="tabs" :entityType="entityType" :entityId="entityId" />
</template>

<script>
import { mapState } from 'vuex';

import Tabs from '@/components/tabs/Tabs';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Widok Profilu
// @group Profile
export default {
  components: { Tabs },
  data() {
    return {
      entityType: TableName.Profile
    };
  },
  computed: mapState({
    entityId: state => state.profile.data.id.toString()
  }),
  props: {
    // Zakładki do wyświetlenia
    tabs: {
      type: Array,
      required: true
    }
  }
};
</script>
